import { render, staticRenderFns } from "./VslBoosterTreinamento.vue?vue&type=template&id=3d2e0300&scoped=true&"
import script from "./VslBoosterTreinamento.vue?vue&type=script&lang=js&"
export * from "./VslBoosterTreinamento.vue?vue&type=script&lang=js&"
import style0 from "./VslBoosterTreinamento.vue?vue&type=style&index=0&id=3d2e0300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e0300",
  null
  
)

export default component.exports